import awsLogo from '../images/aws_small.svg'
import azureLogo from '../images/microsoft_small.svg'
import gcpLogo from '../images/gcp_small.svg'

export const getCloudLogo = (cloud?: string): string => {
  if (!cloud) return awsLogo
  const cloudUpper = cloud.toUpperCase()
  if (cloudUpper === 'AWS') return awsLogo
  if (cloudUpper === 'AZURE' || cloudUpper === 'MICROSOFT') return azureLogo
  if (cloudUpper === 'GCP' || cloudUpper === 'GOOGLE') return gcpLogo
  return awsLogo
}
